// extracted by mini-css-extract-plugin
export default {"menuBlock":"RD-z","title":"SD-z","nav":"TD-z","flexCell":"UD-z","facetLink":"VD-z"};